import styled from 'react-emotion';
import { css } from 'emotion';
import themeConfig from '@lyearn-team/theme-config';

export const LessonItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: none;
  margin-bottom: 18px;
  cursor: pointer;

  .lesson-name {
    margin-left: 8px;
  }
`;

export const LessonGlobalPosition = styled.span`
  background: ${themeConfig.color.dark.earth};
  border-radius: 4px;
  padding: 4px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
`;

export const popupBodyClassName = css`
  max-height: 50vh;
  overflow: auto;
`;
